import { store } from '../../../configureStore';

export const orderNumber = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderNumber;

export const locationCode = store.getState()?.cartDetails?.cartDetailsJson?.cartHeader?.cartCreatorOrderLocationCode;

export const mobileNumber = store.getState()?.cartDetails?.cartDetailsJson?.primaryUserInfo?.address?.phoneNumber;
